import React, { createContext, useContext, useEffect, useState } from "react";
import { CurrentVisit } from "../models/VisitModels/CurrentVisit";
import { logger } from "../../shared/utils/logger";

type VisitContextType = {
    visit: CurrentVisit | null;
    setVisit: (visit: CurrentVisit | null) => void;
};

const VisitContext = createContext<VisitContextType | undefined>(undefined);

export const VisitProvider = ({ children }: { children: React.ReactNode }) => {
    const [visit, setVisit] = useState<CurrentVisit | null>(null);

    // Log per il debug
    useEffect(() => {
        logger.log("VisitContext: visita aggiornata", visit);
    }, [visit]);

    return (
        <VisitContext.Provider
            value={{
                visit,
                setVisit: newVisit => {
                    logger.log("VisitContext: aggiornamento visita", newVisit);
                    setVisit(newVisit);
                }
            }}
        >
            {children}
        </VisitContext.Provider>
    );
};

export const useVisitContext = (): VisitContextType => {
    const context = useContext(VisitContext);
    if (!context) {
        throw new Error("useVisitContext deve essere usato dentro VisitProvider");
    }
    return context;
};
